/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolExploreIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-explore"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.68 16.13L13.1 15.03Q13.82 14.85 14.34 14.34Q14.85 13.82 15.03 13.1L16.13 8.68Q16.23 8.32 15.95 8.05Q15.68 7.78 15.32 7.88L10.9 8.97Q10.18 9.15 9.66 9.66Q9.15 10.18 8.97 10.9L7.88 15.32Q7.78 15.68 8.05 15.95Q8.32 16.23 8.68 16.13ZM12 13Q11.57 13 11.29 12.71Q11 12.43 11 12Q11 11.57 11.29 11.29Q11.57 11 12 11Q12.43 11 12.71 11.29Q13 11.57 13 12Q13 12.43 12.71 12.71Q12.43 13 12 13ZM12 22.8Q9.75 22.8 7.79 21.95Q5.83 21.1 4.36 19.64Q2.9 18.18 2.05 16.21Q1.2 14.25 1.2 12Q1.2 9.75 2.05 7.78Q2.9 5.8 4.36 4.34Q5.83 2.88 7.79 2.04Q9.75 1.2 12 1.2Q14.25 1.2 16.23 2.04Q18.2 2.88 19.66 4.34Q21.13 5.8 21.96 7.78Q22.8 9.75 22.8 12Q22.8 14.25 21.96 16.21Q21.13 18.18 19.66 19.64Q18.2 21.1 16.23 21.95Q14.25 22.8 12 22.8Z" fill={color} />
    </svg>
  );
}
